import {
  API_CALL,
} from './actionConstants'
import {
  FETCH_REFER_EARN_OPTIONS,
  FETCH_REFERRAL_LOGS,
  FETCH_REFERRAL_CODE,
  FETCH_REFERRAL_VALUE,
  FETCH_LETV_QUESTIONS,
  SEND_LETV_ANSWERS,
  FETCH_LETV_PRIZE,
  FETCH_LETV_USER_STATUS,
} from './apiActionConstants'
import {
  getEarnOptions,
  getReferralLogs,
  getReferralValue,
  getLETVQuestions,
  postLETVAnswers,
  getLETVPrize,
  getLETVUserStatus,
} from 'marketing/api'
import { getCodeByUserId } from 'api/promo'
import { AnswersParam } from 'marketing/pages/LETVPage'

export function fetchEarnOptions(region: string) {
  return {
    type: API_CALL,
    api: FETCH_REFER_EARN_OPTIONS,
    request: () => getEarnOptions(region),
  }
}

export function fetchReferralLogs(accessToken?: string) {
  return {
    type: API_CALL,
    api: FETCH_REFERRAL_LOGS,
    request: () => getReferralLogs(accessToken),
  }
}

export function fetchMyReferralCode(memberId: string, accessToken?: string) {
  return {
    type: API_CALL,
    api: FETCH_REFERRAL_CODE,
    request: () => getCodeByUserId(memberId, accessToken),
  }
}

export function fetchReferralValue(region: string) {
  return {
    type: API_CALL,
    api: FETCH_REFERRAL_VALUE,
    request: () => getReferralValue(region),
  }
}

export function fetchLETVQuestions() {
  return {
    type: API_CALL,
    api: FETCH_LETV_QUESTIONS,
    request: () => getLETVQuestions(),
  }
}

export function sendLETVAnswers(answers: AnswersParam) {
  return {
    type: API_CALL,
    api: SEND_LETV_ANSWERS,
    request: () => postLETVAnswers(answers),
  }
}

export function fetchLETVPrize(debugNoSave:boolean) {
  return {
    type: API_CALL,
    api: FETCH_LETV_PRIZE,
    request: () => getLETVPrize(debugNoSave),
  }
}

export function fetchLETVUserStatus(accessToken?: string) {
  return {
    type: API_CALL,
    api: FETCH_LETV_USER_STATUS,
    request: () => getLETVUserStatus(accessToken),
  }
}
